import { LOCALE } from '@/lib/utils/regional';
// Documento imprimible del ESTADO DE CUENTA, con el membrete de la empresa.
// Vive aquí y no dentro de una pantalla porque lo usan dos: la Cartera (botón
// por contraparte) y el reporte de Estado de Cuenta del submenú Reportes.
/* eslint-disable @typescript-eslint/no-explicit-any */

// Documento imprimible "Estado de cuenta" (con logo) a partir de los datos del RPC.
export function htmlEstadoCuenta(d: any): string {
  const esc = (s: unknown) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] as string));
  const money = (v: unknown) => Number(v || 0).toLocaleString(LOCALE, { style: 'currency', currency: 'USD' });
  const fechaCorta = (s: unknown) => (s ? new Date(s as string).toLocaleDateString(LOCALE) : '');
  const emp = d.empresa || {};
  const cli = d.cliente || {};
  const movs: any[] = d.movimientos || [];
  const filas = movs.map((m) => `<tr>
      <td>${fechaCorta(m.fecha)}</td><td>${esc(m.tipo)}</td><td>${esc(m.documento)}</td>
      <td class="r">${m.debe > 0 ? money(m.debe) : ''}</td>
      <td class="r">${m.haber > 0 ? money(m.haber) : ''}</td>
      <td class="r">${money(m.saldo)}</td></tr>`).join('');
  return `<!doctype html><html lang="es"><head><meta charset="utf-8">
<title>Estado de cuenta — ${esc(cli.razon_social)}</title>
<style>
  *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1f2937;margin:24px;font-size:12px}
  header{display:flex;align-items:center;gap:16px;border-bottom:2px solid #111;padding-bottom:12px;margin-bottom:14px}
  header img{height:60px;width:auto}
  .emp{font-size:11px;line-height:1.3} .emp b{font-size:14px}
  h1{font-size:18px;margin:6px 0} .meta{font-size:12px;margin-bottom:12px;line-height:1.5}
  table{width:100%;border-collapse:collapse} th,td{padding:5px 7px;border-bottom:1px solid #e5e7eb}
  thead th{background:#f3f4f6;text-align:left;border-bottom:1px solid #9ca3af}
  .r{text-align:right;white-space:nowrap} tfoot td{font-weight:bold;border-top:2px solid #111}
  .btn{margin-top:16px;padding:8px 14px;border:1px solid #111;background:#111;color:#fff;border-radius:6px;cursor:pointer}
  @media print{.noprint{display:none}}
</style></head><body>
<header>
  ${emp.logo ? `<img src="${esc(emp.logo)}" alt="logo">` : ''}
  <div class="emp"><b>${esc(emp.nombre)}</b><br>${emp.ruc ? 'RUC: ' + esc(emp.ruc) + '<br>' : ''}${emp.direccion ? esc(emp.direccion) + '<br>' : ''}${[emp.telefono, emp.email].filter(Boolean).map(esc).join(' · ')}</div>
</header>
<h1>Estado de Cuenta</h1>
<div class="meta">
  <b>${esc(d.contraparte || 'Cliente')}:</b> ${esc(cli.razon_social)}<br>
  <b>Identificación:</b> ${esc(cli.identificacion)}<br>
  ${d.desde ? `<b>Desde:</b> ${fechaCorta(d.desde)}<br>` : ''}
  <b>Al:</b> ${fechaCorta(d.hasta)}
</div>
<table>
  <thead><tr><th>Fecha</th><th>Tipo</th><th>Documento</th><th class="r">Debe</th><th class="r">Haber</th><th class="r">Saldo</th></tr></thead>
  <tbody>${d.desde ? `<tr><td>${fechaCorta(d.desde)}</td><td><i>Saldo anterior</i></td><td></td><td class="r"></td><td class="r"></td><td class="r"><i>${money(d.saldo_anterior)}</i></td></tr>` : ''}${filas || '<tr><td colspan="6" style="text-align:center;padding:18px">Sin movimientos en el período</td></tr>'}</tbody>
  <tfoot><tr><td colspan="5" class="r">Saldo a la fecha</td><td class="r">${money(d.saldo_final)}</td></tr></tfoot>
</table>
<button class="btn noprint" onclick="window.print()">Imprimir / Guardar PDF</button>
<script>window.onload=function(){setTimeout(function(){window.print()},400)}</script>
</body></html>`;
}
